// File: config.breadcrumbs.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items for the breadcrumbs component.
// Other Contributors:

const rootBreadcrumb = {
    iconClass: 'fa fa-lg fa-home',
    link: {
        enabled: true,
        url: '/'
    }
};

export const breadcrumbs = {
    '': rootBreadcrumb,
    'tprecm': {
        name: 'TPRECM',
        link: { enabled: true, url: '#/tprecm' }
    },
    'view-update-tpr':
    {
        name: 'View/Update TPR',
        link: { enabled: true, url: '#/tprecm/view-update-tpr' }
    },
    'view-update-inactive-tpr':
    {
        name: 'View/Update Inactive TPR',
        link: { enabled: true, url: '#/tprecm/view-update-tpr/inactive' }
    },
    'ecm':
    {
        name: 'ECM',
        link: { enabled: true, url: '#/tprecm/ecm' }
    },
    're-source':
    {
        name: 'Re-Sourced',
        link: { enabled: false }
    },
    'logged-out': [
        rootBreadcrumb,
        {
            name: 'Logged Out',
            link: { enabled: false }
        }
    ],
    '404': [
        rootBreadcrumb,
        {
            name: 'Page Not Found',
            link: { enabled: false }
        }
    ],
    'not-implemented': [
        rootBreadcrumb,
        {
            name: 'Not Implemented',
            link: { enabled: false }
        }
    ],
    'access-denied': [
        rootBreadcrumb,
        {
            name: 'Access Denied',
            link: { enabled: false }
        }
    ]
};
